module.exports = __webpack_public_path__ + "img/defaultImage.982de9b3.png";